import { render } from "./App.vue?vue&type=template&id=77a35107"
const script = {}

import "./App.vue?vue&type=style&index=0&id=77a35107&lang=scss"

import exportComponent from "/builds/web-primary/web-ask-review/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__